// extracted by mini-css-extract-plugin
export default {"card-wrapper":"FontCard_card-wrapper__UidbE","card-inner-wrapper":"FontCard_card-inner-wrapper__5Jbtb","font-family-wrapper":"FontCard_font-family-wrapper__a0FKY"};